// extracted by mini-css-extract-plugin
export default {"defaultCard":"Hm-z","otherCards":"Im-z","empty":"Jm-z","addNewItem":"Km-z","disabled":"Lm-z","cardGrid":"Mm-z"};